export const getShouldHidePricingFlag = (storeId: string): boolean => {
  const listOfIds = process.env.REACT_APP_HIDDEN_STORES_PRICES || '';
  const arrayOfIds = listOfIds.split(',');
  return arrayOfIds.includes(storeId);
};
